export const checkLengthStr = (str: string) => {
  const newStr = [] as string[];
  str.split(' ').forEach((item) => {
    if (item.length > 35) {
      const str = checkItemLengthStr(item);
      return newStr.push(str);
    }
    newStr.push(item);
  });

  return newStr.join(' ');
};

const checkItemLengthStr = (str: string) => {
  let iter = 0;
  const newStr = [] as string[];
  str.split('').forEach((item) => {
    if (iter === 35 && item !== ' ') {
      newStr.push(' ');
      iter = 0;
    } else {
      iter++;
      newStr.push(item);
    }
    if (item === ' ') {
      iter = 0;
    }
  });

  return newStr.join('');
};
